// extracted by mini-css-extract-plugin
export default {"section":"Daughter_section__YZ+Mh","container":"Daughter_container__PQPmP","container__photo":"Daughter_container__photo__+sNYP","photo":"Daughter_photo__IDS7-"};